"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("./common");
const any_1 = require("./any");
function getLinkSchemaModifierProviders(getJoi) {
    const result = Object.assign({}, any_1.getAnySchemaModifierProviders(getJoi));
    return result;
}
exports.getLinkSchemaModifierProviders = getLinkSchemaModifierProviders;
exports.createLinkPropertyDecorator = (reference, joifulOptions) => {
    return common_1.createPropertyDecorator()(({ joi }) => joi.link(reference), getLinkSchemaModifierProviders, joifulOptions);
};
//# sourceMappingURL=link.js.map